import Decimal from 'decimal.js';
import { addDays, addMonths } from 'date-fns';

// Copied from Firefish: packages/app/src/utils/numeric.ts

type DecimalValue = string | number | Decimal;

export function getAmountDue(
  amount: DecimalValue,
  interestRate: DecimalValue,
  period: number
) {
  const startDate = addDays(new Date(), 7);
  const maturityDate = addMonths(startDate, period);
  const daysToMaturity =
    (maturityDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
  // amountDue = amount + (amount * ((interestRate / 100) * (maturityDate - startDate) / 365))
  return new Decimal(amount)
    .mul(interestRate)
    .div(100)
    .mul(daysToMaturity)
    .div(365)
    .plus(amount);
}

export function getFiatOriginationFee(
  amount: string,
  originationFeeRate: string,
  period: number
) {
  return getAmountDue(amount, originationFeeRate, period)
    .minus(amount)
    .toString();
}

export function getBitcoinToSend(originationFee: string, collateral: string) {
  // Bitcoin to send: Origination fee + Bitcoin collateral
  return new Decimal(originationFee).plus(collateral).toFixed(5);
}

export function getOriginationFee(
  btcPrice: string,
  fiatOriginationFee: string
) {
  // Origination fee: FiatOriginationFee / bitcoinPrice
  return new Decimal(fiatOriginationFee).div(btcPrice).toFixed(5);
}

export function getBitcoinCollateral(
  amountDue: DecimalValue,
  btcPrice: DecimalValue,
  ltv0: DecimalValue
) {
  // Bitcoin collateral: Initial Bitcoin Collateral, i.e. = amountDue / (BitcoinPrice * ltv_0)
  return new Decimal(amountDue)
    .div(new Decimal(btcPrice).mul(ltv0).div(100))
    .toFixed(5);
}
